export default "__VITE_ASSET__DDm6jx7N__"